import { useCallback } from 'react'
import type { Dispatch, SetStateAction } from 'react'

import type { SelectedEntity } from './SelectEntityContainer/types'
import type { ReplyAttachment, ReplyAttachmentKind } from './types'

export type UseReplyAttachmentsParams = {
  conversationId: number
  setAttachments: Dispatch<SetStateAction<Map<number, ReplyAttachment[]>>>
  closeModal: () => void
}

export const useReplyAttachments = ({
  conversationId,
  setAttachments,
  closeModal,
}: UseReplyAttachmentsParams) => {
  const handleSelect = useCallback(
    ({ id, cardData }: SelectedEntity) => {
      const kind: ReplyAttachmentKind = 'Listing'

      setAttachments((map) => {
        const next = new Map(map)
        const existing = next.get(conversationId) ?? []
        const filtered = existing.filter(
          (item) => !(item.id === id && item.kind === kind)
        )

        next.set(conversationId, [...filtered, { id, kind, cardData }])
        return next
      })

      closeModal()
    },
    [closeModal, conversationId, setAttachments]
  )

  const handleAttachmentRemove = useCallback(
    (id: number, kind: ReplyAttachmentKind) => {
      setAttachments((map) => {
        const next = new Map(map)
        const existing = next.get(conversationId) ?? []

        next.set(
          conversationId,
          existing.filter((item) => !(item.id === id && item.kind === kind))
        )

        return next
      })
    },
    [conversationId, setAttachments]
  )

  return {
    handleSelect,
    handleAttachmentRemove,
  }
}
